// src/echo.ts
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { SOCKET_AUTH, SOCKET_HOST } from 'src/utils/constant';


declare global {
    interface Window {
        Pusher: typeof Pusher;
    }
}

window.Pusher = Pusher;

export function createEchoInstance(token = null) {
    if (!token) {
        token = localStorage.getItem('accessToken');
    }

    const echo = new Echo({
        broadcaster: 'pusher',
        key: 'c460003ed4b349055c40',
        wsHost: `${SOCKET_HOST || '127.0.0.1'}`,
        wsPort: 6001,
        forceTLS: false,
        disableStats: true,
        encrypted: false,
        cluster: 'mt1',
        authEndpoint: `${SOCKET_AUTH || 'http://127.0.0.1:8000/api/broadcasting/auth'}`,
        auth: {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    });

    // Reconnexion automatique à un canal privé
    echo.connector.pusher.connection.bind('state_change', (states) => {
        console.log('Echo connection state changed:', states);
        if (states.current === 'connected') {
            console.log('Echo is connected. You can resubscribe here.');
        }
    });

    // Gestion des erreurs de connexion
    echo.connector.pusher.connection.bind('error', (err) => {
        console.error('Echo connection error:', err);
    });

    return echo;
}